import './index.scss'

import { initApp, setActiveNav } from 'app/js/app'

setActiveNav()
$(() => {
  initApp()
  // Open modal
  $('#buy_cloudpods').click(function () {
    $('#subscription-body').addClass('body-fixed')
    $('#cloud-mask').addClass('display-block')
  })
  // Close modal
  $('.mask-close').click(function (e) {
    e.preventDefault()
    $('#subscription-body').removeClass('body-fixed')
    $('#cloud-mask').removeClass('display-block')
  })
  $('#cloud-mask').bind('click', function (e) {
    $('#subscription-body').removeClass('body-fixed')
    $('#cloud-mask').removeClass('display-block')
  })
  $('.mask-content').bind('click', function (e) {
    e.stopPropagation()
  })
})




// WEBPACK FOOTER //
// ./src/en/subscription/index.js